<template>
  <div>
    <div class="ticket-list tab-cont prevMatch">
      <div v-for="(item, index) in list" :key="index"
           class="matchBox line" :class="{ticketing: item.type}">
        <div class="bgLogo">
          <div class="bannerTitle">
            {{ item.league_name_txt }}
          </div>
          <div class="matchBox">
            <div class="info pc">
              <div class="bannerTitle">
                {{ item.league_name_txt }}
              </div>
              <div class="stadium">{{ item.game_date }}<span>({{item.yoil}}요일)</span></div>
              <div class="date">{{ item.game_time }}</div>
              <div class="reserveDate" v-if="item.type === '홈'">
                <p v-if="item.game_date !== '2025.09.27'">선예매: {{ item.preReserveDate }}</p>
                <p>본예매: {{ item.reserveDate }}</p>
              </div>
              <div class="field">
                {{ item.field_name }}
                <img src="@/assets/img/icon/icon_map.png" alt="" width="12">
              </div>
            </div>
            <div class="game">
              <div class="emblem home">
                <img :src="getEmblem(item.home_team)" alt="">
                <p>
                  <span class="pc">{{item.home_team_full_name}}</span>
                  <span class="mobile">{{item.home_team_name}}</span>
                </p>
              </div>
              <div class="vs">
                <p class="title">VS</p>
                <p>{{item.type}}</p>
              </div>
              <div class="emblem">
                <img :src="getEmblem(item.away_team)" alt="">
                <p>
                  <span class="pc">{{item.away_team_full_name}}</span>
                  <span class="mobile">{{item.away_team_name}}</span>
                </p>
              </div>
            </div>
            <div class="info">
              <div class="stadium">{{ item.game_date }}<span>({{item.yoil}}요일)</span></div>
              <div class="date">{{ item.game_time }}</div>
              <div class="reserveDate" v-if="item.type === '홈'">
                <p v-if="item.game_date !== '2025.09.27'">선예매: {{ item.preReserveDate }}</p>
                <p>본예매: {{ item.reserveDate }}</p>
              </div>
              <div class="field">
                {{ item.field_name }}
                <img src="@/assets/img/icon/icon_map.png" alt="" width="12">
              </div>
            </div>
          </div>
          <!--
          <div class="btnBox" v-if="checkBrowser() === true">
            <a href="https://ticket.interpark.com/m-ticket/Sports/GoodsInfo?SportsCode=07002&TeamCode=PS011" target="_blank" class="record ticket">티켓예매</a>
            <a href="https://ticket.interpark.com/m-ticket/Sports/GoodsInfo?SportsCode=07002&TeamCode=PS011" target="_blank" class="highlight">예매확인</a>
          </div>
          <div class="btnBox" v-else>
            <a href="https://ticket.interpark.com/Contents/Sports/GoodsInfo?SportsCode=07002&TeamCode=PS011" target="_blank" class="record ticket">티켓예매</a>
            <a href="https://ticket.interpark.com/Contents/Sports/GoodsInfo?SportsCode=07002&TeamCode=PS011" target="_blank" class="highlight">예매확인</a>
          </div>
          -->

          <div class="btnBox">
            <a v-if="item.isOpen" type="button" class="record ticket" @click="callTicketing('ticketing', item.product_code)">티켓예매</a>
            <a type="button" class="highlight" @click="callTicketing('check', item.product_code)">예매확인</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {checkBrowser, getEmblem} from '@/lib';
import {ticketingFunc} from '@/lib/ticketingModule';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
dayjs.locale('ko');

export default {
  name: 'TicketResults',
  props: {
    list: Array
  },
  data() {
    return {
    }
  },
  watch: {
    list: {
      handler: function () {
        this.init();
      }
    }
  },
  methods: {
    checkBrowser,
    getEmblem,
    init() {
      this.list.map(item => {
        const gamedate = item.game_date.replace(/\./g, '-');
        const today = dayjs().format('YYYY-MM-DD');
        const matchDate = dayjs(gamedate).format('YYYY-MM-DD');

        if(item.home_team === 'K07'){
          item.type = '홈';

          item.preReserveDate = dayjs(matchDate).subtract(7, 'day').format('MM.DD(ddd) 14:00');
          item.reserveDate = dayjs(matchDate).subtract(5, 'day').format('MM.DD(ddd) 14:00');
        } else {
          item.type = '원정';
        }

        if(item.meet_name.includes('K리그2')) {
          item.league_name_txt = 'K LEAGUE 2';
        }

        const diffDays = dayjs(matchDate).diff(today, 'day');
        const nowTime = dayjs().format('HH:mm:ss');
        const openTime = '13:50:00';

        if (diffDays === 7 && nowTime >= openTime) {
          item.isOpen = true;
        } else if (diffDays < 7) {
          item.isOpen = true;
        } else {
          item.isOpen = false;
        }

      });
    },
    async callTicketing(type, code) {
      // 로그인 여부 확인
      if (!this.$store.state.login) {
        alert('로그인 후 이용 가능합니다.');
        await this.$router.push('/login');
        return false;
      }
      await ticketingFunc({http: this.$http}, type, code);
    }
  }
}
</script>
<style scoped>
.prevMatch .matchBox .bgLogo .info.pc .stadium {
  margin-bottom: 10px;
}

.prevMatch .matchBox .matchBox .info.pc .bannerTitle,
.tab-cont .matchBox.line .bgLogo .bannerTitle {
  color: #999;
  font-size: 13px;
}
.tab-cont .matchBox.ticketing .bgLogo .info.pc .date,
.prevMatch .matchBox .matchBox .info .date {
  margin-bottom: 8px;
}

@media (max-width: 960px) {
  .tab-cont .matchBox.ticketing .bgLogo .info.pc .date,
  .prevMatch .matchBox .matchBox .info .date {
    margin-bottom: 8px;
  }

  .tab-cont .matchBox.ticketing .matchBox .info .date {
    margin-bottom: 5px;
  }
}
.btnBox a {
  cursor: pointer;
}
</style>
